import { axiosGet, axiosPost } from "../axois_V2/axoisWithAuthV2";
import { throwError } from "../utils/error";

export const donationBaseURL = "/donation/v2"

export type DonationPayload = {
    amount?: number;
    ngoId?: string;
    organisationId?: string;
    cityId: string;
    campaignId: string;
    projects?: Array<{
        projectId: string;
        amount: number;
    }>;
};

interface DonorPayload {
    name: string;
    email: string;
    phone: string;
    userType: "Individual" | "Corporate";
    position?: string;
    pan_number?: string;
}

export interface SubmitDonationFullPayload {
    donor: DonorPayload[];
    donations: DonationPayload[];
    force?: boolean;
}
export const submitDonation_V2 = async (
    payload: SubmitDonationFullPayload,
    force: boolean = false
) => {
    try {
        const res = await axiosPost(`${donationBaseURL}/create?force=${force}`, payload);
        return res?.data;
    } catch (error: any) {
        if (error?.response?.status === 409) {
            throw error;
        }
        throwError(error);
    }
};

export const getAllDonationByOrgOrNgo = async () => {
    try {
        const res = await axiosGet(
            `${donationBaseURL}/donations-by-org-or-ngo`,
        );
        return res;
    } catch (error) {
        throwError(error);
    }
};

export const getDonationsByUser = async () => {
    try {
        const res = await axiosGet(
            `${donationBaseURL}/my-donations`,
        );
        return res
    } catch (error) {
        throwError(error);

    }
}

export const getDonationsByCampaign = async (campaignId: string) => {
    try {
        const res = await axiosGet(`${donationBaseURL}/${campaignId}`);
        return res;
    } catch (error) {
        throwError(error);
    }
};

export const getDonationsByOrgNgo = async () => {
    try {
        const res = await axiosGet(`${donationBaseURL}/donationByOrgNgo`);
        return res;
    } catch (error) {
        throwError(error);
    }
};

export const getDonationsByCity = async () => {
    try {
        const res = await axiosGet(`${donationBaseURL}/donationByCity`);
        return res;
    } catch (error) {
        throwError(error);
    }
};

export const getDonationDetailsById_V2 = async (donationId: string) => {
    try {
        const res = await axiosGet(`${donationBaseURL}/details/${donationId}`);
        return res;
    } catch (error) {
        throwError(error);
    }
};